import React, { forwardRef, ComponentPropsWithRef } from "react";

import { withIssuesConsumer } from "@adsk/acc-issues-common/components/primitive/IssuesConsumer";
import { Issue } from "@adsk/acc-issues-types";
import { ActivityCard, TextActivityCard } from "@adsk/alloy-react-activity-log";

import { ACTIVITY_VARIANTS } from "./constants";
import { useTranslations } from "@adsk/acc-issues-translations";

type IssueActivityCardProps = ComponentPropsWithRef<typeof ActivityCard> & {
  variant?: typeof ACTIVITY_VARIANTS.ADDED | typeof ACTIVITY_VARIANTS.REMOVED;
  entity: Issue;
};

const IssueActivityCard = forwardRef<HTMLDivElement, IssueActivityCardProps>(
  ({ entity, variant, ...rest }, ref) => {
    const { T } = useTranslations();

    return (
      <TextActivityCard
        {...rest}
        ref={ref}
        title={
          variant === ACTIVITY_VARIANTS.REMOVED
            ? T.translate("referencePickerPlugin.activityTitleRemoved")
            : T.translate("referencePickerPlugin.activityTitleAdded")
        }
        text={entity.title}
      />
    );
  }
);

export default withIssuesConsumer(IssueActivityCard);
